import React from 'react';
import { EmailAccount } from './types';

interface EmailAccountSelectorProps {
    emailAccounts: EmailAccount[];
    selectedEmailAccount: string;
    onSelect: (id: string) => void;
}

const EmailAccountSelector: React.FC<EmailAccountSelectorProps> = ({
    emailAccounts,
    selectedEmailAccount,
    onSelect
}) => {
    return (
        <div className="bg-white border-b border-gray-200 p-4 px-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Kayıtlı Email Hesapları</h2>
            {emailAccounts.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {emailAccounts.map((account) => (
                        <div
                            key={account.id}
                            onClick={() => onSelect(account.id)}
                            className={`p-4 border rounded-lg cursor-pointer transition-colors ${selectedEmailAccount === account.id
                                    ? 'border-blue-500 bg-blue-50'
                                    : 'border-gray-200 hover:border-gray-300'
                                }`}
                        >
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="font-medium text-gray-900">{account.email_address}</h3>
                                    <p className="text-sm text-gray-500">{account.provider}</p>
                                    <p className="text-xs text-gray-400">{account.imap_host}:{account.imap_port}</p>
                                </div>
                                <div className={`px-2 py-1 rounded-full text-xs ${account.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                    }`}>
                                    {account.is_active ? 'Aktif' : 'Pasif'}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-8">
                    <p className="text-gray-500 mb-4">Henüz email hesabı eklenmemiş</p>
                    <button
                        onClick={() => window.location.href = '/email-accounts'}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        Email Hesabı Ekle
                    </button>
                </div>
            )}
        </div>
    );
};

export default EmailAccountSelector;
